import React, { useState } from 'react';
import "../../css/gallery.css";
import { gallery } from '../data/Data'; // Ensure this path is correct

function Gallery() {
  const [modalImage, setModalImage] = useState(null);

  const openModal = (imgSrc) => {
    setModalImage(imgSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <>
      <div className="gallery-grid">
        {gallery.map((item, index) => (
          <div key={index} className="gallery-item" onClick={() => openModal(item.img)}>
            <img src={item.img} alt={item.alt} className="gallery-image" />
          </div>
        ))}
      </div>

      {modalImage && (
        <div className="modal" onClick={closeModal}>
          <span className="close" onClick={closeModal}>&times;</span>
          <div className="modal-content">
            <img src={modalImage} alt="Modal Image" className="modal-image" />
          </div>
        </div>
      )}
    </>
  );
}

export default Gallery;
